export default "I, <ADDRESS>, have read the relevant terms and conditions at <LINK> and fully agree with them."